export const tiltTraderConfig = {
  appId: 114286,
  name: "TriplePTrades",
};
